import axios from 'axios'
const { REACT_APP_API_URL } = process.env

axios.defaults.withCredentials = true

const api = axios.create({
  baseURL: REACT_APP_API_URL,
  withCredentials: true
})

api.interceptors.response.use(
  response => response,
  error => {
    const goToLogin = error?.response?.status === 401

    if (goToLogin) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export { api }
